
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetomahbaleshwer() {



    const cardData =
    {
        keyword: 'Pune to Mahabaleshwar Cab',
        heading: 'Mauli Cabs:  Pune to Mahabaleshwar Cab',
        headingDescription: 'Mauli Cabs offers seamless Pune to Mahabaleshwar cab services, ensuring a smooth and comfortable journey to one of Maharashtra’s most scenic hill stations. Whether it is a family vacation, a weekend getaway, or a business trip, we provide a range of vehicles including sedans, SUVs, and premium cars. With professional drivers, no hidden charges, and transparent pricing, we guarantee a stress-free travel experience from Pune to Mahabaleshwar.',

        top: 'Top Places to Visit in Mahabaleshwar with Mauli Cabs',

"topPlaces": [
    {
        "title": "Mahabaleshwar Temple",
        "description": "The Mahabaleshwar Temple is dedicated to Lord Shiva and is an important pilgrimage site in the region. It is known for its ancient architecture and the Atma Lingam, which is said to have divine significance."
    },
    {
        "title": "Venna Lake",
        "description": "Venna Lake is a serene spot known for boating and picnics. Surrounded by lush greenery and hills, it's a peaceful place for families and friends to enjoy a relaxing day amidst nature."
    },
    {
        "title": "Arthur's Seat",
        "description": "Known as the 'Queen of all viewpoints,' Arthur's Seat offers breathtaking views of the surrounding valleys and mountains. It is a popular spot for trekkers and nature lovers seeking scenic vistas."
    },
    {
        "title": "Pratapgad Fort",
        "description": "A historic fort built in the 17th century, Pratapgad Fort is known for its strategic location and beautiful panoramic views. It is famous for the battle between Shivaji Maharaj and Afzal Khan."
    },
    {
        "title": "Elephant's Head Point",
        "description": "A popular viewpoint, Elephant's Head Point offers stunning views of the surrounding valleys and the Western Ghats. The rock formation resembles an elephant's head, making it a must-visit for nature lovers."
    },
    {
        "title": "Wilson Point",
        "description": "Wilson Point is the highest point in Mahabaleshwar, offering magnificent sunrise views. It's a popular spot for early risers looking to witness the beauty of the sun rising over the misty hills."
    },
    {
        "title": "Lingmala Waterfall",
        "description": "Lingmala Waterfall is one of the most popular waterfalls in Mahabaleshwar. Surrounded by lush green forests, it offers a refreshing sight and is a great spot for photography and nature walks."
    },
    {
        "title": "Mapro Garden",
        "description": "A famous strawberry farm, Mapro Garden is known for its delicious strawberry-based products and beautiful gardens. Visitors can enjoy fresh strawberry treats and stroll through the gardens surrounded by colorful flowers."
    },
    {
        "title": "Bombay Point (Sunset Point)",
        "description": "Bombay Point, also known as Sunset Point, is the perfect place to witness a beautiful sunset. The view of the sun setting over the Sahyadri mountains is truly mesmerizing."
    },
    {
        "title": "Maharashtra Nature Park",
        "description": "A great spot for nature lovers and birdwatchers, Maharashtra Nature Park is home to a variety of flora and fauna. It offers serene walking paths and is a great place for relaxation and wildlife observation."
    }
],

"services": [
    {
        "name": "Pune to Mahabaleshwar Cab Service",
        "description": "Mauli Cabs offers reliable and comfortable cab services from Pune to Mahabaleshwar. Whether you're visiting for sightseeing or a holiday, we ensure a smooth and enjoyable ride."
    },
    {
        "name": "Book Pune to Mahabaleshwar Taxi",
        "description": "Book your taxi from Pune to Mahabaleshwar with Mauli Cabs. We offer a range of vehicles for a comfortable and convenient trip to this beautiful hill station."
    },
    {
        "name": "Affordable Pune to Mahabaleshwar Cab",
        "description": "Mauli Cabs offers affordable and reliable cab services for your journey from Pune to Mahabaleshwar. Enjoy a cost-effective and comfortable ride with no hidden charges."
    },
    {
        "name": "Luxury Cab from Pune to Mahabaleshwar",
        "description": "Travel in style with Mauli Cabs' luxury cab services for your trip from Pune to Mahabaleshwar. Our fleet of premium vehicles ensures a luxurious and comfortable experience."
    },
    {
        "name": "Mahabaleshwar Trip by Cab from Pune",
        "description": "Plan your trip from Pune to Mahabaleshwar with Mauli Cabs. Our well-maintained vehicles and professional drivers make your trip hassle-free and enjoyable."
    },
    {
        "name": "Private Taxi for Mahabaleshwar from Pune",
        "description": "Choose a private taxi from Pune to Mahabaleshwar with Mauli Cabs for a more personalized and comfortable experience. Enjoy privacy and convenience during your journey."
    },
    {
        "name": "Mahabaleshwar Sightseeing by Taxi from Pune",
        "description": "Explore the beauty of Mahabaleshwar with Mauli Cabs' sightseeing taxi services. Our experienced drivers will guide you through all the must-see spots for a memorable trip."
    },
    {
        "name": "Group Travel to Mahabaleshwar",
        "description": "Traveling with a group? Mauli Cabs offers spacious vehicles to accommodate your entire group for a comfortable and stress-free journey from Pune to Mahabaleshwar."
    },
    {
        "name": "Comfortable Taxi Service from Pune to Mahabaleshwar",
        "description": "Mauli Cabs provides comfortable and reliable taxi services from Pune to Mahabaleshwar, ensuring a smooth and enjoyable trip with well-maintained vehicles."
    },
    {
        "name": "Mahabaleshwar Holiday by Private Taxi",
        "description": "Plan your Mahabaleshwar holiday with a private taxi from Pune. Mauli Cabs offers personalized services for a relaxing and luxurious trip to the hill station."
    }
],

"tableData": [
    ["Pune to Mahabaleshwar Cab Service", "Book Pune to Mahabaleshwar Taxi"],
    ["Affordable Pune to Mahabaleshwar Cab", "Luxury Cab from Pune to Mahabaleshwar"],
    ["Mahabaleshwar Trip by Cab from Pune", "Private Taxi for Mahabaleshwar from Pune"],
    ["Mahabaleshwar Sightseeing by Taxi from Pune", "Group Travel to Mahabaleshwar"],
    ["Comfortable Taxi Service from Pune to Mahabaleshwar", "Mahabaleshwar Holiday by Private Taxi"]
],



"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "At Mauli Cabs, we understand the importance of timely travel for your Pune to Mahabaleshwar Cab. Whether you're planning a peaceful getaway or a leisure trip, our drivers ensure timely pickups and drop-offs, making sure you enjoy a stress-free journey."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "We offer a variety of vehicles for your Pune to Mahabaleshwar Cab, from sedans to SUVs and premium cars, all designed to ensure your utmost comfort. Enjoy spacious interiors, air conditioning, and ample legroom for a relaxed ride to the hills."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced drivers are familiar with the Pune to Mahabaleshwar route, ensuring a smooth and safe journey. With knowledge of the best roads and traffic patterns, they make sure your trip is both enjoyable and hassle-free."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers affordable and transparent pricing for your Pune to Mahabaleshwar Cab. We ensure there are no hidden fees, so you can focus on enjoying your trip while we provide you with a fair price for your journey."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our priority. All our vehicles are regularly maintained and equipped with modern safety features such as airbags, seat belts, and GPS tracking. Our drivers adhere to safety protocols, ensuring a secure and smooth ride to Mahabaleshwar."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Mauli Cabs is available 24/7 for your Pune to Mahabaleshwar Cab. Whether you need an early morning departure or a late-night ride, our customer service team is ready to assist you at any time."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your Pune to Mahabaleshwar Cab with Mauli Cabs is quick and easy. You can book online via our website or mobile app, or simply contact our customer service team for personalized assistance with your reservation."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Whether you're planning a family vacation, a romantic getaway, or a solo adventure, Mauli Cabs offers customized travel packages for your Pune to Mahabaleshwar Cab. Share your preferences, and we'll tailor the journey to suit your needs."
    }
]





    }



    const faqData = [
        {
            question: 'How do I book a cab from Pune to Mahabaleshwar with Mauli Cabs?',
            answer: 'Booking your cab is simple! You can book directly through our website or mobile app. Just enter Pune as your pickup location and Mahabaleshwar as your destination, then choose the vehicle that fits your needs. Alternatively, you can call our support team for assistance.',
        },
        {
            question: 'What types of cabs are available for Pune to Mahabaleshwar?',
            answer: 'Mauli Cabs offers a variety of vehicles, including Sedans, SUVs, Ertiga, Innova Crysta, and premium options. Choose the one that best suits your comfort and space requirements.',
        },
        {
            question: 'Is the fare from Pune to Mahabaleshwar fixed?',
            answer: 'Yes, the fare is fixed and transparent. It includes tolls, taxes, and driver charges. No hidden costs—you’ll know the total fare upfront.',
        },
        {
            question: 'Can I book a round trip from Pune to Mahabaleshwar?',
            answer: 'Yes, you can easily book both one-way and round-trip rides. Just provide your return details when making the booking, and we’ll take care of the rest.',
        },
        {
            question: 'How long does the journey from Pune to Mahabaleshwar take?',
            answer: 'The ride from Pune to Mahabaleshwar typically takes around 3.5 to 4 hours, depending on traffic and road conditions. We aim to provide a smooth and timely journey.',
        },
        {
            question: 'Are your drivers experienced with the Pune to Mahabaleshwar route?',
            answer: 'Yes, our drivers are experienced and well-trained, familiar with the best routes to ensure a safe and comfortable ride to Mahabaleshwar.',
        },
        {
            question: 'Can I book a cab for sightseeing in Mahabaleshwar?',
            answer: 'Yes, Mauli Cabs offers customized sightseeing tours in Mahabaleshwar. Whether you want to visit popular spots or hidden gems, our drivers will make your trip enjoyable.',
        },
        {
            question: 'Are the cabs air-conditioned and well-maintained?',
            answer: 'Absolutely! All our cabs are fully air-conditioned and well-maintained for cleanliness and comfort. We ensure a pleasant and hygienic ride for you.',
        },
        {
            question: 'Can I cancel or modify my booking after confirmation?',
            answer: 'Yes, you can cancel or modify your booking. Our flexible cancellation policy is available through the website or app, and our customer support team is always available to help you.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune to Mahabaleshwar trip?',
            answer: 'Mauli Cabs offers competitive pricing, a range of vehicle options, professional drivers, and reliable service. Whether for leisure or a weekend getaway, we ensure a comfortable and hassle-free trip to Mahabaleshwar.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Vikram Joshi",
            position: "Weekend Traveler",
            text: "A fantastic journey from Pune to Mahabaleshwar. The cab was comfortable, and the driver was courteous and knowledgeable about the route. Highly recommend Mauli Cabs!",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Sneha Reddy",
            position: "Nature Enthusiast",
            text: "The drive to Mahabaleshwar was smooth, and we had an amazing experience. The car was well-maintained, and the driver made sure we were comfortable throughout the trip.",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Mahabaleshwar Cab by Mauli Cabs",
        "description": "Mauli Cabs offers affordable and comfortable cab services from Pune to Mahabaleshwar. Enjoy a smooth ride in private or luxury taxis, ideal for sightseeing, family trips, and group travel. Online booking available 24x7.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "4900"
        }
      };
      
     
      


    return (
        <div>
            <GTag/>

<Helmet>
        <title>Pune to Mahabaleshwar Cab | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book a cab from Pune to Mahabaleshwar with Mauli Cabs. Affordable, comfortable private and luxury taxis for sightseeing, family travel, and holidays. 24x7 online cab booking available."
        />
        <meta
          name="keywords"
          content="Pune to Mahabaleshwar cab service, Book Pune to Mahabaleshwar taxi, Affordable Pune to Mahabaleshwar cab, Luxury cab from Pune to Mahabaleshwar, Mahabaleshwar trip by cab from Pune, Private taxi for Mahabaleshwar from Pune, Mahabaleshwar sightseeing by taxi from Pune, Group travel to Mahabaleshwar, Comfortable taxi service from Pune to Mahabaleshwar, Mahabaleshwar holiday by private taxi"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>


            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/3.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomahbaleshwer;